import * as React from "react";

import { FlexComponent } from "typings/flexFramework/FlexComponent";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

import { LobFormWithTabs } from "components/shared/StorefrontWizard/LobFormWithTabs/LobFormWithTabs";
import { LobQueryRouter } from "components/shared/StorefrontWizard/LobQueryRouter";

export interface WizardForTripsHeroProps {
  wizardLOBs: FlexComponent[];
  wizardFormChildren: React.ReactElement[];
  trackOnChangeTab: (tabName: string, rfrrId?: string) => void;
  context: ExtendedContextStore;
}

export const WizardForTripsHero: React.FC<WizardForTripsHeroProps> = ({
  wizardLOBs,
  wizardFormChildren,
  trackOnChangeTab,
  context,
}) => (
  <>
    <LobQueryRouter lobs={wizardLOBs} />

    <div className="all-y-padding-three SimpleContainer">
      <LobFormWithTabs context={context} lobForms={wizardFormChildren} trackOnChangeTab={trackOnChangeTab} />
    </div>
  </>
);
